import React from "react";
import Select from "react-select";
import classnames from "classnames";
import _ from "lodash";
import { FormattedMessage, injectIntl } from "react-intl";

import "./style.scss";
import ToolTip from "components/ToolTip";
import { Info } from "components/Icons";

const CNBSelect = ({
  label = "",
  containerClassName = "",
  selectedOption = "" as any,
  hasTooltip = false,
  tooltipText = "",
  placeholder = "MAKE_CHOICE",
  input = {} as any,
  clearable = true,
  meta = { touched: false, error: null },
  intl: { formatMessage },
  ...props
}) => {
  const placeholderText = placeholder ? formatMessage({ id: placeholder }) : "";
  const formattedToolTip = tooltipText
    ? formatMessage({ id: tooltipText })
    : "";
  if (selectedOption) {
    const { options } = props;
    selectedOption =
      typeof selectedOption !== "object"
        ? options.find((option) => option.value === selectedOption)
        : selectedOption;
  }
  return (
    <div
      className={classnames("cnb-select", containerClassName, {
        error: meta.touched && meta.error,
      })}
    >
      {hasTooltip && (
        <div className="label-container">
          {label && <FormattedMessage id={label} tagName="label" />}
          <ToolTip content={formattedToolTip}>
            <Info />
          </ToolTip>
        </div>
      )}
      {label && !hasTooltip && label && (
        <FormattedMessage id={label} tagName="label" />
      )}
      <Select
        {...input}
        value={_.isEmpty(input) ? selectedOption : input.value}
        onBlur={() => input.onBlur && input.onBlur(input.value)}
        placeholder={placeholderText}
        isClearable={clearable}
        {...props}
      />
      {meta.touched && meta.error && (
        <span className="error-wrapper">{meta.error}</span>
      )}
    </div>
  );
};

export default injectIntl(CNBSelect);
